import React, { useEffect } from 'react';
import { useSelector, useDispatch, useStore } from 'react-redux';
import isLoggedIn from 'global/utils/isLoggedIn';
import { _size } from '../global/utils';
import useRetrieveData from '../global/hooks/useRetrieveData';
import { get } from '../global/lib/lodash';
import { SET_ACCOUNT_SETTINGS } from '../redux/actions/types';
import { getViewStyle } from '../redux/actions/view';

export const LoadAccountSettings = props => {
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));
  const uid = useSelector(state => get(state, 'auth.user.id'));
  const rid = useSelector(state => get(state, 'auth.realm.id'));
  const dispatch = useDispatch();

  const { data } = useRetrieveData({
    url: rid ? `/account-settings?realm_id=${rid}` : '/account-settings',
  }, {
    useEffect: true,
    waitFor: !!loggedIn && !!uid,
    build: ['accountSettings'],
    useCache: {
      reload: 20
    }
  })

  useEffect(() => {
    if (loggedIn && _size(data)) {
      dispatch({ type: SET_ACCOUNT_SETTINGS, accountSettings: data });
      dispatch(getViewStyle(rid, data))
    }
  }, [loggedIn, data]);

  return null;
}